import React from 'react';

import PropTypes from 'prop-types';
import { Button, Divider, Typography } from '@telus-uds/components-web';
import Download from '@telus-uds/palette-allium/build/web/icons/Download';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import request, { isOrderFulfillmentTeam } from '../../utils/request';
import { CONSTANT } from '../../utils/constant';
import Attachements from './attachements';

const OrderAttachments = ({ links, orderData }) => {
  const localizedString = useLocalizedStringsContext();
  const {
    ORDERS: { quotePdf, contractUnSigned, contractSignedPdf, attachments }
  } = localizedString;
  const {
    KEYS: {
      ROLES: { SALES_MANAGER, SALES_REP, SALES_SUPPORT, ORDER_FULFILLMENT }
    }
  } = CONSTANT;
  const {
    role: { name: roleId }
  } = request.getProfile();
  const uploadAttachementAvailable = roleId === ORDER_FULFILLMENT;
  const isLinkAvailable = [
    SALES_REP,
    ORDER_FULFILLMENT,
    SALES_MANAGER,
    SALES_SUPPORT
  ].includes(roleId);

  const getRow = (name, label) =>
    links[name] ? (
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div>{label}</div>
        <div>
          <Button
            icon={Download}
            onPress={() => window.open(links[name], '_blank')}
            accessibilityLabel="Download"
            variant={{ text: true }}
          />
        </div>
      </li>
    ) : null;
  const linkSignedPdf =
    isLinkAvailable && getRow('contractSignedPdf', contractSignedPdf);

  return (
    <>
      <>
        <Divider space={2} variant={{ inverse: true }} />
        <Typography heading="h2" variant={{ size: 'h2' }} block>
          {attachments}
        </Typography>
        <Divider space={2} variant={{ inverse: true }} />
        <div className="card">
          <div className="card-header">
            <Typography heading="h4" variant={{ size: 'h4' }} block>Quote/Contract pdf</Typography>
          </div>
          <ul className="list-group list-group-flush">
            {getRow('quotePdf', quotePdf)}
            {isOrderFulfillmentTeam &&
              getRow('contractUnSigned', contractUnSigned)}
            {linkSignedPdf && linkSignedPdf}
          </ul>
        </div>
        <Attachements
          isUploadAvailable={uploadAttachementAvailable}
          orderData={orderData}
        />
      </>
    </>
  );
};

OrderAttachments.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      quotePdf: PropTypes.string,
      contractUnSigned: PropTypes.string,
      contractSignedPdf: PropTypes.string
    })
  ).isRequired
};

export default OrderAttachments;
